export default __webpack_public_path__ + "static/media/saint-cloud.774d4693.jpg";